import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/error';
import { AuthenticationGuard } from './shared/guard/authentication-guard';
import { HomeRedirectGuard } from './shared/guard/home-redirect-guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, HomeRedirectGuard],
    children: [],
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
    canActivate: [],
    canActivateChild: [],
    data: {
      title: 'APP_TITLE',
      header: 'HEADER_SUBTITLE',
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
